import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  NgZone,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { LoadingComponent } from '@app/core/layout/loading/loading.component';
import { GoogleAuthService } from '@app/core/services/google-auth.service';
import { SignInWithGoogle } from '@app/store';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-check-oauth-token',
  templateUrl: './check-oauth-token.page.html',
  styleUrls: ['./check-oauth-token.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LoadingComponent],
})
export class CheckOauthTokenPage implements OnInit {
  constructor(
    private store: Store,
    private googleAuthService: GoogleAuthService,
    private oAuthService: OAuthService,
    private ngZone: NgZone,

    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.oAuthService
      .tryLogin()
      .then((value: boolean) => {
        if (value) {
          const token = this.googleAuthService.getToken();
          if (token) {
            this.ngZone.run(() => {
              this.store.dispatch(new SignInWithGoogle(token));
            });
          } else {
            this.redirect();
          }
        } else {
          this.redirect();
        }
      })
      .catch(() => {
        this.redirect();
      });
  }

  private redirect(): void {
    this.ngZone.run(() => {
      this.store.dispatch(new Navigate(['/auth']));
    });
  }
}
